// extracted by mini-css-extract-plugin
module.exports = {"ImageCopySectionContainer__gallery":"styles_ImageCopySectionContainer__gallery__covvx","ImageCopySectionContainer__image":"styles_ImageCopySectionContainer__image__25N2P"};